import { z } from 'zod';

export const employeeSchema = z.object({
  username: z.string().min(1, 'El nombre de usuario es obligatorio'),
  password: z.string().min(8, 'La contraseña debe tener al menos 8 caracteres'),
  card_id: z.string().min(1, 'El ID de tarjeta es obligatorio'),
});